import * as firebase from 'firebase'
import * as React from 'react'
import { firebaseAuthSettings } from './const'
import logo from './logo.png'

enum STATE {
	NONE,
	LOADING,
	SENT,
	ERROR
}

const ERROR_MESSAGES = {
	'auth/invalid-email': 'Tohle nevypadá jako správný mail.'
}

interface IState {
	state: STATE
	email: string
	error: any
}

export default class Login extends React.PureComponent<IState> {
	public state = {
		email: '',
		error: null,
		state: STATE.NONE
	}

	private handleSubmit = e => {
		e.preventDefault()
		this.setState({ state: STATE.LOADING, error: null })

		const email = this.state.email
		firebase
			.auth()
			.sendSignInLinkToEmail(email, firebaseAuthSettings)
			.then(() => {
				window.localStorage.setItem('emailForSignIn', email)
				this.setState({ state: STATE.SENT })
			})
			.catch(error => {
				// Some error occurred, you can inspect the code: error.code
				console.error(error)
				this.setState({ state: STATE.ERROR, error })
			})
	}

	private handleEmailChange = e => {
		this.setState({ email: e.target.value })
	}

	public render() {
		const disabled = [STATE.LOADING, STATE.SENT].includes(this.state.state)

		return (
			<div className="Login-screen">
				<div className="Login-logoWrap">
					<img
						className="Login-logo"
						src={logo}
						alt="We love srnky"
					/>
				</div>
				<div className="Login-texts">
					<h2 className="Login-heading">Starej se o svoji srnku!</h2>
					<p className="Login-quote">
						Pro přihlášení zadej svůj email.
					</p>
					{this.state.state === STATE.ERROR && (
						<p>
							Něco se nepodařilo.{' '}
							{(this.state.error &&
								ERROR_MESSAGES[this.state.error.code]) ||
								this.state.error.message}
						</p>
					)}
					{this.state.state === STATE.SENT && (
						<p>
							Podívej se do mailu - měl by ti přijít email s
							přihlašovacím okazem.
						</p>
					)}
					<form className="Login-form" onSubmit={this.handleSubmit}>
						<input
							className="Login-email"
							type="email"
							placeholder="Email"
							onChange={this.handleEmailChange}
							disabled={disabled}
							value={this.state.email}
						/>
						<input
							className="Login-button"
							disabled={disabled}
							type="submit"
							value="Přihlásit"
						/>
					</form>
				</div>
			</div>
		)
	}
}



// WEBPACK FOOTER //
// ./src/Login.tsx